const state = {
    defaultTheme:'#141C23'
}
const mutations = {
    changeTheme(state,data){
        state.defaultTheme = data
        window.localStorage.setItem('vue-theme',data);
    }
}
const actions = {
    getTheme({commit},data){
        console.log('theme actions:',state.defaultTheme);
        return new Promise((reslove)=>{
            if(window.localStorage.getItem('vue-theme')){
                state.defaultTheme = window.localStorage.getItem('vue-theme')
            }
            reslove();
        })
        
    },
    setTheme({commit},data){
        console.log('changetheme',data);
        return new Promise((reslove)=>{
            commit('changeTheme',data);
            reslove();
        })
        
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}